import { render } from "./SearchFilters.vue?vue&type=template&id=2b4dffbe&scoped=true"
import script from "./SearchFilters.vue?vue&type=script&lang=js"
export * from "./SearchFilters.vue?vue&type=script&lang=js"

import "./SearchFilters.vue?vue&type=style&index=0&id=2b4dffbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4dffbe"]])

export default __exports__